import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useCollection } from "../useData";
import { resolveImg } from "../api";
import SEO from "../components/SEO";

const SORTS = [
  { key: "newest", label: "Newest" },
  { key: "price-asc", label: "Price ↓" },
  { key: "price-desc", label: "Price ↑" },
];

const Shop = () => {
  const [sort, setSort] = useState("newest");
  const shopProducts = useCollection("shop_products") || [];

  const items = useMemo(() => {
    const list = [...shopProducts];
    if (sort === "price-asc") return list.sort((a, b) => a.price - b.price);
    if (sort === "price-desc") return list.sort((a, b) => b.price - a.price);
    return list.sort((a, b) => b.year - a.year);
  }, [sort, shopProducts]);

  return (
    <div className="px-6 md:px-10 max-w-[1100px] mx-auto">
      <SEO
        title="Shop — Books & Prints"
        description="Books and prints by Alice Lisi. Forthcoming titles: Dal Primo Giorno and Space of the Exception. Signed prints on request."
        path="/shop"
      />
      <div className="pt-2 pb-8 flex items-baseline justify-between">
        <span className="font-serif italic text-[color:var(--ink-mute)]">Shop — Books & Prints</span>
        <div className="flex items-center gap-5">
          {SORTS.map((s) => (
            <button
              key={s.key}
              onClick={() => setSort(s.key)}
              className={`font-serif tlink ${sort === s.key ? "tlink-active" : "tlink-mute"}`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="border-t border-[color:var(--line)] pt-10 grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-16 pb-16">
        {items.map((p) => (
          <Link to={`/shop/${p.id}`} key={p.id} className="tile group">
            <div className="aspect-square bg-[color:var(--paper-2)] overflow-hidden">
              {p.cover ? (
                <img src={resolveImg(p.cover)} alt={p.title} loading="lazy" decoding="async" className="tile-img w-full h-full object-cover" />
              ) : null}
            </div>
            <div className="mt-4 flex items-baseline justify-between gap-3">
              <div>
                <p className="font-serif italic text-lg leading-tight">{p.title}</p>
                <p className="font-serif text-[color:var(--ink-mute)] mt-0.5">Book — {p.year}</p>
              </div>
              <span className="font-serif counter">€{typeof p.price === "number" ? p.price.toFixed(2) : "—"}</span>
            </div>
          </Link>
        ))}
      </div>

      {/* Films strip pointer */}
      <div className="border-t border-[color:var(--line)] pt-10 pb-6 flex items-baseline justify-between">
        <div>
          <p className="font-serif italic text-[color:var(--ink-mute)]">Looking for the films?</p>
          <p className="font-serif text-2xl mt-1">All three documentaries are free to watch.</p>
        </div>
        <Link to="/films" className="font-serif italic tlink">Go to Films →</Link>
      </div>
    </div>
  );
};

export default Shop;
